/**
 * Broker Data Pipeline — routes for the audit section (ADR-047), mounted at /broker-pipeline/*.
 *
 * Laid out like the Load Data Pipeline: one entry per thing in the pipeline, ordered as the data flows. Writers, the
 * topic, then the consumer.
 */

import { Navigate, Route, Routes } from 'react-router-dom'
import ConsumerPage from './ConsumerPage'
import BrokeragePage from './consumer/BrokeragePage'
import OverviewPage from './OverviewPage'
import QuarantinePage from './QuarantinePage'
import TopicPage from './TopicPage'
import WriterPage from './WriterPage'

export default function BrokerPipelineRoutes() {
    return (
        <Routes>
            <Route index element={<OverviewPage />} />
            <Route path="overview" element={<OverviewPage />} />

            {/* Writers: one page each, from the core's closed list */}
            <Route path="writer/:writer" element={<WriterPage />} />
            <Route path="writer" element={<Navigate to="/broker-pipeline/writer/fmcsa" replace />} />
            <Route path="quarantine" element={<QuarantinePage />} />

            {/* Topic */}
            <Route path="topic" element={<TopicPage />} />

            {/* Consumer — broker search (ADR-047.1), tabbed; each brokerage has its own page */}
            <Route path="consumer/brokerage/:mc" element={<BrokeragePage />} />
            <Route path="consumer/:tab" element={<ConsumerPage />} />
            <Route path="consumer" element={<Navigate to="refusals" replace />} />
        </Routes>
    )
}
